// sanitizeInput function
//
//    uses DOMPurify to clean inputs prior to use
//    also limits input length to a fixed number
//

import DOMPurify from 'dompurify';

// global app constant. MOVE TO ENVIROMENT VARIABLE
const MAXSTRINGLENGTH = 150
const MAX_NAME_LENGTH = 60
const MAX_CAMPAIGN_LENGTH = 50
const MAX_URL_LENGTH = 200
const MAX_TITLE_LENGTH = 100

const sanitizeInput = (input) => {
  if (input.length > MAXSTRINGLENGTH ) {
    alert('Max field length is 100 characters. Concatenating');
    input = input.slice(0,MAXSTRINGLENGTH+1);
  }
  return DOMPurify.sanitize(input);
};

// Strip all HTML and JS from a character or campaign name
const _stripTags = (input) =>
  DOMPurify.sanitize(input.trim(), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

export const sanitizeCharName = (input) => {
  if (!input || typeof input !== 'string') return '';
  const clean = _stripTags(input);
  return clean.slice(0, MAX_NAME_LENGTH);
};

export const sanitizeCampaignName = (input) => {
  if (!input || typeof input !== 'string') return '';
  const clean = _stripTags(input);
  return clean.slice(0, MAX_CAMPAIGN_LENGTH);
};

// Sites explicitly allowed for campaign URLs (currently unused — only BANNED_SITES is enforced)
// eslint-disable-next-line no-unused-vars
export const ALLOWED_SITES = [
  'discord.com',
  'dropbox.com',
  'dragonaxegames.com',
  's.dxadev.com',
];

export const BANNED_SITES = [
  // Adult content
  'xvideos.com', 'pornhub.com', 'xhamster.com', 'redtube.com', 'youporn.com',
  'tube8.com', 'xnxx.com', 'brazzers.com', 'onlyfans.com', 'chaturbate.com',
  'livejasmin.com', 'myfreecams.com', 'cam4.com', 'stripchat.com',
  // Major news sites
  'cnn.com', 'espn.com', 'msnbc.com', 'foxnews.com', 'nytimes.com',
  'washingtonpost.com', 'nbcnews.com', 'abcnews.go.com', 'cbsnews.com',
  'bbc.com', 'bbc.co.uk', 'huffpost.com', 'usatoday.com', 'apnews.com',
  'reuters.com', 'theguardian.com', 'nypost.com', 'politico.com',
];

// Returns null if the URL is not https or the domain is in BANNED_SITES
export const sanitizeURL = (input) => {
  if (!input || typeof input !== 'string') return null;
  const clean = _stripTags(input);
  if (clean.length > MAX_URL_LENGTH) return null;
  if (!/^https:\/\//i.test(clean)) return null;
  try {
    const hostname = new URL(clean).hostname.toLowerCase();
    const isBanned = BANNED_SITES.some(site => hostname === site || hostname.endsWith('.' + site));
    if (isBanned) return null;
  } catch {
    return null;
  }
  return clean;
};

// Sanitize spell descriptions: allow safe formatting tags, strip <script> and anything dangerous
const SPELL_ALLOWED_TAGS = ['b', 'i', 'strong', 'em', 'pre', 'br', 'p', 'span', 'ul', 'ol', 'li'];
const SPELL_ALLOWED_ATTR = ['class'];

export const sanitizeSpellDescription = (input) => {
  if (!input || typeof input !== 'string') return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: SPELL_ALLOWED_TAGS,
    ALLOWED_ATTR: SPELL_ALLOWED_ATTR,
  });
};

export const sanitizeRuleTitle = (input) => {
  if (!input || typeof input !== 'string') return '';
  const clean = _stripTags(input);
  return clean.slice(0, MAX_TITLE_LENGTH);
};

export default sanitizeInput
